;!(function ($) {
    $.fn.elasticAttr = function (options) {

        // Event onResize
        // =================
        var update = function (el) {

                var dSteps         = $(el).data('steps'); // JSON format
                var dataOpt       = {};
                if (typeof(dSteps) === 'object') dataOpt.steps = dSteps;

                var settings = $.extend(
                    {
                        steps: []     /* { minScreen : 768, maxScreen : 1200, min:1, max:100, type:'em',attr:'font-size'} */
                    }, dataOpt, options);


                var viewportWidth = $(window).width();
                var calculated = 100;
                var $el = $(el);

                if (settings.steps.length > 0) {

                    $.each(settings.steps, function () {

                        var step = this;

                        if($.isArray(this))
                        {
                            console.log('Is array of steps');
                            step = getStep(this,viewportWidth);

                        }


                        var view = (viewportWidth > step.maxScreen) ? step.maxScreen : (viewportWidth < step.minScreen) ? step.minScreen : viewportWidth;
                        calculated =
                            scale(view,
                                step.minScreen,
                                step.maxScreen,
                                step.min,
                                step.max
                            );


                            $el.css(step.attr, calculated + step.type);
                            $el.trigger('elasticattr.scaled');




                    });

                }else{
                    console.error('steps isn\'t an array of step');
                }


        },
        // get the default index if not exist step
        //=========================================
         getDefault = function(items,viewport)
         {

             var res={index:-1,distance:10000000};

             $.each(items, function (i,step) {

                 // minor distance
                 if((viewport < step.minScreen))
                 {
                     var temp={index:i,distance:(step.minScreen-viewport)};

                      if(temp.distance<res.distance)
                      {
                            res=temp;
                      }
                 }
             });


             if(res.index<0)
             {
                 console.log('Not step on default get the last item :'+res.index);
                 res.index=(items.length-1);
             }

             console.log('getDeault:'+res.index);

             return res.index;

         },
         // The correct step
         //=======================
         getStep = function(items,viewport)
         {
             var index=-1;

             $.each(items, function (i,step) {

                 // between min and max
                 if((viewport>=step.minScreen) && (viewport<=step.maxScreen))
                 {
                    index=i;
                    return false;
                 }
             });

             // If not exist step for viewport, get the default
             if(index<0)
             {
                 index = getDefault(items,viewport);
             }

                 console.log('getStep:' + index);
                 return items[index];

         },
        // Scale factor
        // ============
            scale = function (valueIn, baseMin, baseMax, limitMin, limitMax) {
                return ((limitMax - limitMin) * (valueIn - baseMin) / (baseMax - baseMin)) + limitMin;
            };

        // Make the magic visible
        // ======================
        return this.each(function () {
            // Context for resize callback
            var me = this;
            // Make changes upon resize
            $(window).resize(function () {
                update(me);
            });
            // Set changes on load
            update(this);
        });
    };

    $(window).on('load', function () {

        $('.elastic[data-tools="elasticattr"]').elasticAttr();
    });

}(jQuery));